import { Link } from "react-router-dom";
import "../styles/about-page.css";
import { useEffect } from "react";
export default function AboutPage() {
  useEffect(() => {
    document.title = "amantes30 | About";
    const navIcons = document.querySelectorAll(".icon-wrapper");
    navIcons.forEach((icon) => {
      icon.classList.remove("active");
    });
    const selectedIcon = document.getElementById("About-icon");
    if (selectedIcon) {
      selectedIcon.classList.add("active");
    }
  }, []);
  return (
    <div className="about-page">
      <section className="hero">
        <h1 className="hero-text">about amantes30</h1>
        <p className="hero-desc">
          Independent software development studio turning ideas into real,
          working products.
        </p>
        <div className="card special">
          <div className="profile-pic">
            <img alt="" src="/images/profile.webp" />
          </div>
          <div className="info">
            <p>Name: Amanuel Tesfaye</p>
            <p>Age: 26</p>
            <p>Profession: Software Engineer | Co-Founder</p>
            <p>Location: Ethiopia</p>

            <div className="contact-links">
              <div>
                <a href="tel:+251969344221">
                  <img alt="" src="/images/14.webp" />
                </a>
              </div>
              <div>
                <a href="https://t.me/iTelegram30">
                  <img alt="" src="/images/55.webp" />
                </a>
              </div>
              <div>
                <a href="https://amantes30.com">
                  <img alt="" src="/images/33.webp" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="mission" style={{ animationTimeline: "view()" }}>
        <h2 className="gc-text">the story</h2>
        <p>
          amantes30 is a <span className="gc-text">solo-run studio</span> built
          by a developer who cares about clarity, quality, and building things
          that actually solve problems. No bureaucracy. No big-agency nonsense.
          Just focused, thoughtful work executed with precision. Started as a
          one-person mission, the studio now collaborates with businesses,
          startups, and teams that need fast, reliable, and modern software
          without the headache.
        </p>
      </section>
      <section className="team" style={{ animationTimeline: "view()" }}>
        <h2 className="gc-text">mission</h2>
        <p>
          Focused on building practical digital products and AI-powered
          solutions. I help businesses automate work, streamline operations, and
          launch custom software—while also developing my own tools and
          platforms. My goal is simple: build fast, build smart, and deliver
          real value without the overhead of big teams.
        </p>
      </section>
      <section className="history" style={{ animationTimeline: "view()" }}>
        <h2 className="gc-text">History</h2>
        <p>Founded in 2020, I have consistently delivered quality solutions.</p>
      </section>
      <section className="values" style={{ animationTimeline: "view()" }}>
        <h2 className="gc-text">My Values</h2>
        <ul>
          <li>
            <b className="gc-text">Transparency</b>:{" "}
            <span>No surprises, just clear communication.</span>
          </li>
          <li>
            <b className="gc-text">Quality over speed</b>:{" "}
            <span>I prioritize doing things right over doing them fast.</span>
          </li>
          <li>
            <b className="gc-text">Collaborations</b>:{" "}
            <span>
              I believe in working together to achieve the best results.
            </span>
          </li>
          <li>
            <b className="gc-text">Simplicity</b>:{" "}
            <span>Keeping things straightforward and easy to understand.</span>
          </li>
        </ul>
      </section>
      <section className="mission" style={{ animationTimeline: "view()" }}>
        <h2 className="gc-text">the person behind the studio</h2>
        <p>
          Hey, I’m Aman — a full-stack developer who loves building useful
          things. I’ve worked on web apps, mobile apps, automation tools, and
          digital solutions that help businesses run faster. I’m obsessed with
          clean UI, smooth user experience, and practical problem-solving. When
          I work with clients, I treat the project like it’s mine — because it
          kinda is.
        </p>
      </section>

      <section className="values" style={{ animationTimeline: "view()" }}>
        <h2 className="gc-text">Tech stack</h2>
        <ul>
          <li>ReactJS</li>
          <li>Node.js, Express</li>
          <li>MongoDB / PostgreSQL / Supabase</li>
          <li>Flutter / React Native </li>
          <li>Unity</li>
          <li>Vercel / Azure / Cloudflare</li>
        </ul>
      </section>

      <section className="call-to-action">
        <h2 className="gc-text">
          Want to build something together? Let’s talk.
        </h2>
        <Link to="/contact" className="p-btn">
          Start a project
        </Link>
      </section>
    </div>
  );
}
